import { apiEmpleo } from "../../util/ApiEmpleo";
import { TApiCollectionResponse } from "../apiCoreV2.types";
import { TGetCuideoDiscardedValuationsCollectionItem } from "./valuation.types";

export interface IApiListCuideoDiscardedValuationsParams {
  candidateId: string;
}

export const apiListCuideoDiscardedValuations = async (
  params: IApiListCuideoDiscardedValuationsParams
) => {
  let res: TApiCollectionResponse<TGetCuideoDiscardedValuationsCollectionItem> =
    await apiEmpleo.get(`valoraciones/cuideo-discarded/${params.candidateId}`);

  return res;
};
